import jwtDecode from 'jwt-decode';
import { FluentJwtPayload, tokenUtility } from '../token';
import { PROD, resolveEnv } from '@fluentsms/utils';
import { useMemo } from 'react';

export const useEnv = () => {
  return useMemo(() => {
    const resolvedEnv = resolveEnv();

    return resolvedEnv === PROD ? '' : `${resolvedEnv.toLowerCase()}.`;
  }, []);
};

export const useIdToken = (): string | null => {
  return tokenUtility.getIdToken();
};

export const useDecodedToken = (): FluentJwtPayload | null => {
  const token = useIdToken();

  return useMemo((): FluentJwtPayload | null => {
    return token ? jwtDecode<FluentJwtPayload>(token) : null;
  }, [token]);
};

export const useTenantId = (): string => {
  const decodedToken = useDecodedToken();

  return decodedToken?.[tokenUtility.getUserTokenDomain()]?.tenantId ?? '';
};

export function useUserId() {
  const decodedToken = useDecodedToken();

  return decodedToken?.[tokenUtility.getUserTokenDomain()]?.userId ?? '';
}
